export default __webpack_public_path__ + "static/media/bwTheme-boy.ad15928f.svg";